import {AppDocumentType} from "./AppDocumentType";
import {RREventStatusType, RREventStatusTypeList} from "./RREventStatusType";
import {MaybeDate} from "./Maybe";
import {RRDepartmentType} from "./RRDepartmentType";

export type RREventType = AppDocumentType & {
    eventNumber: string;
    eventName: string;
    eventShortName: string;
    eventStatus: RREventStatusType,
    eventColor?: string
    planningRevision?: number;
    eventCategory: RRDepartmentType,
    place?: string;
    clientEmail: string;
    clientName: string;
    clientPhone?: string;
    clientSpoc?: string;
    firstDate?: Date;
    lastDate?: MaybeDate;
    face?: string;
    notes?: string;
    isDeleted?: boolean;
    isCatering: boolean;
    isStore: boolean;
    isMontage: boolean;
}

export type RREventsType = RREventType[];

export const EMPTY_RR_EVENT: RREventType = {
    id: "",
    eventNumber: "",
    eventName: "",
    eventShortName: "",
    eventStatus: "НОВО",
    eventCategory: "MONTAGE",
    clientEmail: "",
    clientName: "",
    isCatering: false,
    isStore: false,
    isMontage: false,
    isDeleted: false,
    face: "",
    notes: "",
    place: "",
    firstDate: new Date(),
    lastDate: null,
    clientPhone: "",
    clientSpoc: "",
}
